(function () {
  const DEFAULT_ALT = "Baker's Gas";

  function setAltIfMissing(img) {
    if (
      img.tagName === 'IMG' &&
      (!img.getAttribute('alt') || img.getAttribute('alt').trim() === '')
    ) {
      img.setAttribute('alt', DEFAULT_ALT);
      console.log('Added ALT');
    }
  }

  // 1. Review existing images
  document.querySelectorAll('img').forEach(setAltIfMissing);

  // 2. Listen to new uploads with Lazysizes
  document.addEventListener('lazyloaded', function (e) {
    setAltIfMissing(e.target);
  });

  // 3. Observe changes in the DOM (for dynamic images)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.tagName === 'IMG') {
            setAltIfMissing(node);
          }
          node.querySelectorAll?.('img').forEach(setAltIfMissing);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();